import React, { Component } from "react";

import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class DifficultyLevelCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      // user: {},
      loading: false
    };

    this.error = this.error.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    const { id } = this.props.match.params;
    if (id) {
      this.setState(
        () => ({
          loading: false
        }),
        () => {
          axios
            .get(`${URL.api}classification/difficulty_level/singleView/${id}`, {
              headers: { authorization: `Bearer ${this.props.user.token}` }
            })
            .then(resp => {
              this.setState(
                () => ({
                  difficulty_level: resp.data.data
                }),
                () => {
                  this.setState(() => ({
                    edit: true,
                    loading: false
                  }));
                },
                error => {
                  this.error(error.response.statusText);
                }
              );
            });
        }
      );
    }
  }

  enviar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name
    };
    axios
      .post(`${URL.api}classification/difficulty_level/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.props.history.push("/difficultylevel/list");
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  atualizar(value) {
    let obj = {
      loggedUser: this.props.user.user.id,
      name: value.name
    };
    axios
      .post(
        `${URL.api}classification/difficulty_level/update/${value.id}`,
        obj,
        { headers: { authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.props.history.push("/difficultylevel/list");
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  render() {
    const Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    let buttons = [
      {
        name: "Enviar",
        submit: false,
        icon: "fa fa-cloud",
        iconSide: "left",
        custom: this.enviar,
        color: "primary"
      }
    ];

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            { path: "/difficultylevel/list", to: "/difficultylevel/list" }
          ]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Form
            avatar
            fields={Fields}
            buttons={buttons}
            back
            history={this.props.history}
            onSubmit={this.state.edit ? this.atualizar : this.enviar}
            initialValues={this.state.difficulty_level}
            edit={this.state.edit}
          />
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DifficultyLevelCreate);
